import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useContext, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { Button } from '_lib/components/Button/Button';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { Stack } from '_lib/components/Stack/Stack';

import { Typography } from '_lib/components/Typography/Typography';

import { SimpleAppBar } from '../../components/AppBar/SimpleAppBar';
import { AppDrawerState, AppRouteContext } from '../App/app.types';
import { AuthContext } from '../auth/authContext';
import { ScrollableContentWrapper } from '../ScrollableContentWrapper/ScrollableContentWrapper';

interface ForbiddenProps {
  appDrawerState?: AppDrawerState;
}

const Forbidden = (props: ForbiddenProps) => {
  const { appDrawerState } = props;

  // TODO: `navigate(-1)` appears to not be working as expected, with 2 clicks needed to go back to the previous page
  const navigate = useNavigate();

  const { authUserCacheResource } = useContext(AuthContext);

  const authUserQuery = authUserCacheResource.useCacheQuery();

  useEffect(() => {
    // If we somehow get here without an auth user (shouldn't be possible through normal navigation), navigate to login page
    if (!authUserQuery.data) {
      navigate('/auth/login');
    }
  }, [authUserQuery, navigate]);

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar title='Forbidden' onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer} />
      <ScrollableContentWrapper>
        <Stack spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }} padding={2}>
          <Typography
            variant='h3'
            text={'You do not have the required permissions to access the requested resource.'}
          />
          <Button
            color='primary'
            onClick={() => navigate(-1)}
            startIcon={<ArrowBackIcon />}
            text='Back'
            variant='contained'
          />
        </Stack>
      </ScrollableContentWrapper>
    </FlexBox>
  );
};

export const ForbiddenRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();
  return <Forbidden appDrawerState={appDrawerState} />;
};
